// extracted by mini-css-extract-plugin
export default {"wrap":"kK-z","articleImagesWrap":"lK-z","articleImage":"mK-z","singleImage":"nK-z"};